(ns manage.adset-decision-tree-page.view.side-panel.ad-variants
  (:require ["@mui/material/Alert$default" :as Alert]
            ["@mui/material/AlertTitle$default" :as AlertTitle]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Collapse$default" :as Collapse]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/List$default" :as List]
            ["@mui/material/ListItem$default" :as ListItem]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["@mui/material/Typography$default" :as Typography]
            ["src/svg/objects/tag.svg$default" :as Tag]
            ["src/svg/wpp/arrows/trend-ascent.svg$default" :as TrendAscent]
            ["src/svg/wpp/content/calendar.svg$default" :as Calendar]
            [common.flags :refer [use-flag]]
            [common.queries :refer [use-query]]
            [common.resource.query.adset :as adset.q]
            [manage.ad-variant.widgets :as variant-widgets]
            [manage.adset-decision-tree-page.ad-variant-table-ocp.view :as-alias ad-variant-table-ocp]
            [manage.adset-decision-tree-page.view.common
             :refer [ad-variant-menu
                     content-id-text
                     side-panel-list-item
                     upgrade-ad-variants-button
                     warning-icon
                     preview-button
                     product-store-menu]]
            [manage.adset-decision-tree-page.view.hook :as hook]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui variant-details-button [{:keys [variant-row-ids]}]
  (when (use-flag :decision-tree-ad-variant-table)
    ($ Button {:variant "outlined"
               :onClick #(rf/dispatch [:ocp/open
                                       {:id ::ad-variant-table-ocp/ad-variant-table
                                        :props {:variant-row-ids (set variant-row-ids)
                                                :read-only true}}])}
       "Details")))

(defui ad-variant-details-line
  [{{:keys [uuid ad-variant-status ad-formats trackers click-through-url-tagging scheduling]} :ad-variant
    :keys [on-upgrade on-configuration ad-variant errors read-only] :as props}]
  (let [first-ad-format (first ad-formats)
        has-product-selector? (some->> first-ad-format
                                       :dynamic-content
                                       vals
                                       (some #(= "products" (:source-type %))))]
    ($ Stack {:direction "row"
              :justifyContent "space-between"
              :gap 1
              :alignItems "center"
              :sx #js {:overflow "auto"}}
       ($ variant-widgets/ad-variant-type-info
          {:ad-variant (assoc ad-variant :dimensions first-ad-format)
           :sx #js {:mr "auto"}})
       (when-not (= ad-variant-status "approved")
         ($ variant-widgets/status-chip
            {:status ad-variant-status}))
       (when (:timezone scheduling)
         ($ Stack {:sx #js {:py 1}}
            ($ variant-widgets/scheduling-info-icon scheduling)))
       (when (some? on-upgrade)
         ($ upgrade-ad-variants-button props))
       (if read-only
         ($ preview-button {:ids [uuid]})
         ($ Stack {:direction "row"
                   :alignItems "center"}
            (when has-product-selector?
              ($ product-store-menu props))
            ($ IconButton {:on-click on-configuration}
               ($ SvgIcon
                  {:component Tag
                   :color (cond
                            (some? errors) "warning"

                            ;; TODO choose from the theme colors
                            (or (some? trackers) (some? click-through-url-tagging)) "blue"

                            :else "")})))))))

(defui flat-list-item [{:keys [ad-variant] :as props}]
  (let [single-ad-variant-control (hook/use-single-ad-variant-control props)]
    ($ side-panel-list-item {:sx #js {:display "block"
                                      :pl 1
                                      :pr 0}}
       ($ Stack {:direction "row"
                 :justifyContent "space-between"
                 :alignItems "center"}
          ($ content-id-text ad-variant)
          ($ ad-variant-menu single-ad-variant-control))

       ($ ad-variant-details-line single-ad-variant-control))))

(defui group-item [props]
  (let [single-ad-variant-control (hook/use-single-ad-variant-control props)]
    ($ ListItem {:component "div"
                 :disablePadding true
                 :sx #js {:display "block"}}
       ($ ad-variant-details-line single-ad-variant-control))))

(defui collapsable-group
  [{:keys [group-child-props group-content-id ad-variants-in-group group-status]
    :as group-props}]
  (let [[expanded set-expanded] (uix/use-state false)
        {:keys [on-upgrade] :as controls} (hook/use-grouped-ad-variant-control group-props)]
    ($ side-panel-list-item {:sx #js {:flexDirection "column"
                                      :alignItems "flex-start"}}
       ($ Stack {:direction "row"
                 :alignItems "center"
                 :gap 1
                 :sx #js {:width "100%"}}
          ($ IconButton {:onClick #(set-expanded not)}
             ($ Icon (if expanded "expand_more" "chevron_right")))
          ($ content-id-text {:child-count (count ad-variants-in-group)
                              :content-id group-content-id
                              :sx #js {:mr "auto"}})
          (when (some? group-status)
            ($ variant-widgets/status-chip
               {:status group-status}))
          (when (some :errors group-child-props)
            ($ warning-icon {:tooltip-title "Tagging or tracker misconfigured"}))
          (when (some (comp :timezone :scheduling) ad-variants-in-group)
            ($ SvgIcon {:component Calendar
                        :inheritViewBox true}))
          (when on-upgrade
            ($ upgrade-ad-variants-button controls))
          ($ ad-variant-menu controls))
       ($ Collapse {:in expanded
                    :sx #js {:width "100%"}}
          ($ List {:component "div"
                   :disablePadding true
                   :sx #js {:pl 4
                            :pt 0.5
                            :borderTop 1
                            :borderColor "grey.60"}}
             (for [props group-child-props]
               ($ group-item props)))))))

(defui add-or-change-button [{:keys [single-default-per-dimensions ad-variants edit-variants]}]
  (let [any-variants-assigned (seq ad-variants)]
    ($ Button
       {:variant "contained"
        :sx #js {:alignSelf "end"}
        :color "grey"
        :startIcon ($ Icon (if (and any-variants-assigned single-default-per-dimensions)
                             "autorenew"
                             "add"))
        :onClick edit-variants}
       (if single-default-per-dimensions
         (if any-variants-assigned
           "Change ad variant"
           "Add ad variant")
         "Add ad variants"))))

(defui aco-alert [{:keys [multiple-ad-variants?]}]
  (let [alert-config (if multiple-ad-variants?
                       {:severity "success"
                        :icon TrendAscent
                        :title "Ad variants are optimized"
                        :description "We will adjust variant weight based on ad performance."}
                       {:severity "warning"
                        :icon TrendAscent
                        :title "Optimization not applied"
                        :description "Optimization is enabled, but requires at least two variants."})]
    ($ Alert
       {:severity (:severity alert-config)
        :icon ($ (:icon alert-config))}
       ($ AlertTitle (:title alert-config))
       (:description alert-config))))

(defui ad-variant-list [{:keys [has-multiple-templates child-props]}]
  (let [{:keys [advertiser-id adset-id]} (use-subscribe [:url-context])
        ad-variant-list-item (if has-multiple-templates collapsable-group flat-list-item)
        {{:keys [test-state]} :data} (use-query (adset.q/adset-aco-active-configuration
                                                 {:advertiser-id advertiser-id
                                                  :adset-id adset-id}))]
    ($ :<>
       (when (= test-state "started")
         ($ aco-alert
            {:multiple-ad-variants? (> (count child-props) 1)}))
       ($ List
          (for [props child-props]
            ($ ad-variant-list-item props))))))

(defui ad-variant-section
  [{:keys [selected-item]
    {:keys [hide-add-button empty-text single-default-per-dimensions]} :variant-properties}]
  (let [{:keys [any-variants-assigned] :as list-controls}
        (hook/use-ad-variant-controls {:selected-item selected-item
                                       :single-default-per-dimensions single-default-per-dimensions})]
    ($ Stack {:spacing 1}
       (when-not hide-add-button
         ($ add-or-change-button (assoc list-controls :single-default-per-dimensions single-default-per-dimensions)))
       (if any-variants-assigned
         ($ ad-variant-list list-controls)
         (when (some? empty-text)
           ($ Typography {:sx #js {:color "text.secondary"}}
              empty-text))))))
